import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {PartialLoadingIndicatorComponent} from './partial-loading-indicator.component';
import {LoadingIndicatorModule} from '../loading-indicator';

@NgModule({
    imports: [
        CommonModule,
        LoadingIndicatorModule
    ],
    declarations: [
        PartialLoadingIndicatorComponent
    ],
    exports: [
        PartialLoadingIndicatorComponent
    ]
})
export class PartialLoadingIndicatorModule {}
